import React from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import * as config from '../config';

export default function SeoTags({
  title,
  description,
  image,
  image_alt,
  keywords,
  children,
  link,
  pagePath,
  author
}) {
  image = image || '../image/logo.svg';
  pagePath = pagePath || '';

  return (
    <Helmet
      title={title}
      link={link}
      meta={[
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { name: 'author', content: `${author}, liam@autokwix.com` },
        { name: 'copyright', content: 'All rights reserved, autokwix.com' },
        { property: 'og:type', content: 'article' },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: image_alt },
        { property: 'og:url', content: config.siteUrl + pagePath },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: config.twitterSite },
        { name: 'twitter:title', content: title },
        { name: 'twitter:url', content: config.siteUrl + pagePath },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
      ]}
    >
      {children}
    </Helmet>
  )
}

SeoTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  image_alt: PropTypes.string,
  link: PropTypes.array,
  children: PropTypes.array,
  author: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/seo-tags.js